import { useEffect, useState } from "react";
import { api } from "../api.ts";

interface Policy { type: string; label: string; level: number; configuredLevel: number; earnedLevel: number; ceiling: number; frozen: boolean; reason: string; configurable: boolean }
const LEVELS = ["L0 只观察", "L1 只建议", "L2 待确认", "L3 执行并通知", "L4 自动处理"];
export function AutonomyControl(props: { users: { id: string; name: string; active: boolean }[]; canEdit: boolean }): React.JSX.Element {
  const [userId, setUserId] = useState("");
  const [policies, setPolicies] = useState<Policy[]>([]);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");
  const load = async (id: string): Promise<void> => {
    try { const r = await api.get<{ policies: Policy[] }>(`/api/manager/autonomy?userId=${id}`); setPolicies(r.policies); setErr(""); }
    catch (e) { setErr((e as Error).message); }
  };
  useEffect(() => { if (userId) void load(userId); }, [userId]);
  const save = async (p: Policy, level: number, frozen: boolean): Promise<void> => {
    setBusy(p.type); setErr("");
    try { await api.patch("/api/manager/autonomy", { userId, actionType: p.type, level, frozen }); await load(userId); }
    catch (e) { setErr((e as Error).message); } finally { setBusy(""); }
  };
  return <section className="card">
    <div className="secttl">AI 自主度与冻结</div>
    <p className="hint">权限由采纳、纠正数据逐级挣得。你可以降低上限、解除临时限制或冻结,不能直接升到 AI 尚未挣到的档位。金钱与合同永远由人决定。</p>
    <select aria-label="选择自主度成员" value={userId} onChange={(e) => setUserId(e.target.value)}>
      <option value="">选择成员</option>{props.users.filter((u) => u.active).map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
    </select>
    {err && <p className="err">{err}</p>}
    {userId && <div className="table-scroll"><table className="tbl"><thead><tr><th>动作</th><th>档位</th><th>冻结</th></tr></thead><tbody>
      {policies.filter((p) => p.configurable).map((p) => <tr key={p.type}><td>{p.label}<div className="muted">{p.reason}</div></td><td>
        <select aria-label={`${p.label}档位`} disabled={!props.canEdit || busy === p.type} value={p.configuredLevel}
          onChange={(e) => void save(p, Number(e.target.value), p.frozen)}>
          {LEVELS.map((label, i) => i <= p.earnedLevel ? <option key={i} value={i}>{label}</option> : null)}
        </select></td><td><input aria-label={`冻结${p.label}`} type="checkbox" disabled={!props.canEdit || busy === p.type} checked={p.frozen}
          onChange={(e) => void save(p, p.configuredLevel, e.target.checked)} /></td></tr>)}
    </tbody></table></div>}
  </section>;
}
